import { useEffect, useRef, useState } from "react";
import { apiFetch } from "~/lib/fetchClient";

export const mapById = (item) => ({ value: String(item.id), label: item.name });
export const mapByValue = (item) => ({ value: item, label: item });

// BUG-14 fix: Added error state and timeout to prevent indefinite "Loading..." state
const FETCH_TIMEOUT_MS = 15000;

const useDropdownOptions = (
  url,
  { mapOption = mapById, extractData, params, client = apiFetch } = {},
) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(!!url);
  const [error, setError] = useState(false);

  // Use refs to always have the latest callbacks without causing re-fetches
  const extractDataRef = useRef(extractData);
  const mapOptionRef = useRef(mapOption);
  extractDataRef.current = extractData;
  mapOptionRef.current = mapOption;

  useEffect(() => {
    if (!url) {
      setData([]);
      setLoading(false);
      setError(false);
      return;
    }

    setLoading(true);
    setError(false);
    const req = client.get(url, params ? { params } : undefined);

    // Timeout fallback in case the request hangs
    const timeout = setTimeout(() => {
      req.abort();
      setLoading(false);
      setError(true);
    }, FETCH_TIMEOUT_MS);

    req
      .then((response) => {
        clearTimeout(timeout);
        const extractor = extractDataRef.current;
        const extracted = extractor ? extractor(response) : response;
        setData(Array.isArray(extracted) ? extracted : []);
      })
      .catch(() => {
        clearTimeout(timeout);
        setData([]);
        setError(true);
      })
      .finally(() => setLoading(false));

    return () => {
      clearTimeout(timeout);
      req.abort();
    };
  }, [url]);

  const options = Array.isArray(data) ? data.map(mapOptionRef.current) : [];

  return { options, loading, error };
};

export default useDropdownOptions;
